export default __webpack_public_path__ + "static/media/chave-sombreada.4b0d9398.svg";